<template>
  <v-dialog v-model="visible" max-width="500" persistent>
    <v-card>
      <v-card-title class="headline mb-0">{{ title }}</v-card-title>
      <v-card-title v-if="subtitle" class="headline">{{ subtitle }}</v-card-title>

      <v-card-text>{{ description }}</v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="failureText" color="green darken-1" text @click="$emit('failureCallback')">{{ failureText }}</v-btn>
        <v-btn color="green darken-1" text @click="$emit('successCallback')">{{ successText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  props: ["visible", "title", "subtitle", "description", "successText", "failureText"],
  methods: {}
};
</script>

<style>
.v-card__text, .v-card__title {
  word-break: normal !important;
}

</style>
